import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DoctorService } from '../../services/doctor.service';
import { NgForm } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
@Component({
  selector: 'app-popupform',
  templateUrl: './popupform.component.html',
  styleUrls: ['./popupform.component.css']
})
export class PopupformComponent implements OnInit {
  action: any;
  msg: any;
  sd: any;
  etime: any;
  stime: any;
  constructor(public DialogRef: MatDialogRef<PopupformComponent>,
     @Inject(MAT_DIALOG_DATA) public data: any, private doctorservice: DoctorService, private snackbar: MatSnackBar) {
       this.stime = data.stime;
       this.etime = data.etime;
       this.sd = data.sduration;
      }

  ngOnInit() {
  }
  updateMySchedule() {
    this.doctorservice.updateMyDaySchedule(this.data.id, this.data.stime, this.data.etime, this.data.sduration)
    .subscribe(
      (c) => {
        this.closeAfterEdit();
      });
  }

  submit() {
    this.msg = 'Submitted';
    this.openSnackBar();
  }
  openSnackBar() {
    this.snackbar.open(this.msg , this.action,{
      duration: 4000,
    });
  }

  editMySchedule() {
    if (this.data.stime === this.stime && this.data.etime === this.etime && this.sd === this.data.sduration) {
      this.closewithoutEdit();
    } else {
      this.updateMySchedule();
      }
  }

  closewithoutEdit() {
    const result = 0;
    this.DialogRef.close(result);
  }

closeAfterEdit() {
  const result = 1;
  this.DialogRef.close(result);
}
}
